import { useMutation } from 'react-query';
import { network } from 'services/network';

const mutationFn = (params: QueryParams) => {
    return network.post('api/bo/resetClustersList', params).then((response) => response.data);
};

export const useMutationResetCluster = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    clusterId: number;
    clusterType: string;
}
